import React, {Component, Fragment} from 'react';
import { connect } from "react-redux";
import moment from 'moment';
import {setActiveDate, setActiveDateType, setStandardDate} from "../../../actions/statistics/statisticsActions";
import autobind from 'autobind-decorator'
import classnames from 'classnames';
import {firstDayOfMonth, thisMondayDate, now} from './CommonHelper';


@connect(state => ({
  standardDate: state.statistics.standardDate,
  activeDate: state.statistics.activeDate,
  activeDateType: state.statistics.activeDateType,
}), dispatch => ({
  handleSetStandardDate(standardDate) {
    dispatch(setStandardDate(standardDate))
  },
  // 활성화된 날짜 변경
  handleSetActiveDate(activeDate) {
    dispatch(setActiveDate(activeDate))
  },
  // 활성화된 날짜 타입 변경 (day, week, month)
  handleSetActiveDateType(activeDateType) {
    dispatch(setActiveDateType(activeDateType))
  }
}))
class GraphHeader extends Component {


  constructor(props) {
    super(props);
    this.defaultFormat = "YYYY-MM-DD";
    moment.locale("ko");
  }

  componentDidMount() {
    this.props.handleSetActiveDate(now());
  }

  @autobind
  displayDateFormat() {
    const {activeDate, activeDateType} = this.props;
    switch (activeDateType) {
      default:
      case "day" :
        return moment(activeDate).format("YYYY.MM.DD ddd");
      case "week" :
        const start = thisMondayDate(activeDate, "YYYY-MM-DD");
        const end = moment(start).add(6, "day").format("YYYY.MM.DD"); // 일요일까지니깐 6일
        return `${moment(start).format("YYYY.MM.DD")} ~ ${end}`;
      case "month" :
        return moment(activeDate).format("YYYY.MM");
    }
  }

  @autobind
  changeDateType(type) {
    let changedDate = now();

    if (type == 'week') {
      changedDate = thisMondayDate(changedDate, this.defaultFormat);
    }
    else if (type == 'month') {
      changedDate = firstDayOfMonth(changedDate, this.defaultFormat);
    }

    this.props.handleSetStandardDate(changedDate);
    this.props.handleSetActiveDate(changedDate);
    this.props.handleSetActiveDateType(type);
  }

  render() {
    const dateText = this.displayDateFormat();
    const {activeDateType} = this.props;

    return (
      <Fragment>
        <div className="date_graph">
          <span className="tit_date week">{dateText}</span>
        </div>
        <div className="tab_graph">
          <strong className="screen_out">그래프단위 선택 목록</strong>
          <ul className="list_tab">
            <li className={classnames({on: activeDateType == 'day'})}>
              <button className="btn_tab" onClick={() => {
                this.changeDateType('day')
              }}>일간
              </button>
            </li>
            <li className={classnames({on: activeDateType == 'week'})}>
              <button className="btn_tab" onClick={() => {
                this.changeDateType('week')
              }}>주간
              </button>
            </li>
            <li className={classnames({on: activeDateType == 'month'})}>
              <button className="btn_tab" onClick={() => {
                this.changeDateType('month')
              }}>월간
              </button>
            </li>
          </ul>
        </div>
      </Fragment>
    );
  }
}

export default GraphHeader;
